module.exports = __webpack_public_path__ + "static/media/wp.78b499b2.svg";